import axios from "@/api/axios"

const getLocationCategories = () => {
    return axios.get('/ref/location/category')
        .then(response => response.data);
}

const getLocationTypes = id => {
    return axios.get(`/ref/location/type/${id}`)
        .then(response => response.data)
}

export default {
    getLocationCategories,
    getLocationTypes
}
